export const getGoogleAuth2Instance = async (): Promise<{
  auth2: gapi.auth2.GoogleAuth;
}> => {
  const auth2 = window.auth2;

  if (auth2) {
    return {
      auth2,
    };
  } else {
    return new Promise((resolve) => {
      gapi.load('auth2', () => {
        const newAuth2 = gapi.auth2.init({
          client_id: browserRootConfig.authentication.google.oauth.client_id,
          cookie_policy: 'single_host_origin',
          fetch_basic_profile: true,
          ux_mode: 'redirect',
        });

        window.auth2 = newAuth2;
        resolve({ auth2: newAuth2 });
      });
    });
  }
};

export const googlePlatformLibraryLogin = async (): Promise<any> => {
  const { auth2 } = await getGoogleAuth2Instance();

  return auth2.signIn({
    ux_mode: 'redirect',
  });
};

export const googlePlatformLibraryLogout = async (): Promise<void> => {
  const { auth2 } = await getGoogleAuth2Instance();
  const is_signed_in = auth2.isSignedIn.get();

  if (!is_signed_in) {
    return undefined;
  } else {
    return auth2.signOut().then(() => undefined);
  }
};
